export default {"src":"/_next/static/image/public/images/radiology_reports.c12075e6993e1446cd0373cacc3640ed.svg","height":177,"width":176};